import Vue from 'vue';
const $t = Vue.i18n.translate;

export default () => [
    { value: null, text: $t('data.provinces.(Seleccionar)', '(Seleccionar)'), disabled: true },
    { value: "A Coruña", text: $t('data.provinces.A Coruña', 'A Coruña') },
    { value: "Álava/Araba", text: $t('data.provinces.Álava/Araba', 'Álava/Araba') },
    { value: "Albacete", text: $t('data.provinces.Albacete', 'Albacete') },
    { value: "Alicante/Alacant", text: $t('data.provinces.Alicante/Alacant', 'Alicante/Alacant') },
    { value: "Almería", text: $t('data.provinces.Almería', 'Almería') },
    { value: "Asturias", text: $t('data.provinces.Asturias', 'Asturias') },
    { value: "Ávila", text: $t('data.provinces.Ávila', 'Ávila') },
    { value: "Badajoz", text: $t('data.provinces.Badajoz', 'Badajoz') },
    { value: "Barcelona", text: $t('data.provinces.Barcelona', 'Barcelona') },
    { value: "Burgos", text: $t('data.provinces.Burgos', 'Burgos') },
    { value: "Cáceres", text: $t('data.provinces.Cáceres', 'Cáceres') },
    { value: "Cádiz", text: $t('data.provinces.Cádiz', 'Cádiz') },
    { value: "Cantabria", text: $t('data.provinces.Cantabria', 'Cantabria') },
    { value: "Castellón/Castelló", text: $t('data.provinces.Castellón/Castelló', 'Castellón/Castelló') },
    { value: "Ceuta", text: $t('data.provinces.Ceuta', 'Ceuta') },
    { value: "Ciudad Real", text: $t('data.provinces.Ciudad Real', 'Ciudad Real') },
    { value: "Córdoba", text: $t('data.provinces.Córdoba', 'Córdoba') },
    { value: "Cuenca", text: $t('data.provinces.Cuenca', 'Cuenca') },
    { value: "Girona", text: $t('data.provinces.Girona', 'Girona') },
    { value: "Granada", text: $t('data.provinces.Granada', 'Granada') },
    { value: "Guadalajara", text: $t('data.provinces.Guadalajara', 'Guadalajara') },
    { value: "Guipúzcoa/Gipuzkoa", text: $t('data.provinces.Guipúzcoa/Gipuzkoa', 'Guipúzcoa/Gipuzkoa') },
    { value: "Huelva", text: $t('data.provinces.Huelva', 'Huelva') },
    { value: "Huesca", text: $t('data.provinces.Huesca', 'Huesca') },
    { value: "Islas Baleares/Illes Balears", text: $t('data.provinces.Islas Baleares/Illes Balears', 'Islas Baleares/Illes Balears') },
    { value: "Jaén", text: $t('data.provinces.Jaén', 'Jaén') },
    { value: "La Rioja", text: $t('data.provinces.La Rioja', 'La Rioja') },
    { value: "Las Palmas", text: $t('data.provinces.Las Palmas', 'Las Palmas') },
    { value: "León", text: $t('data.provinces.León', 'León') },
    { value: "Lleida", text: $t('data.provinces.Lleida', 'Lleida') },
    { value: "Lugo", text: $t('data.provinces.Lugo', 'Lugo') },
    { value: "Madrid", text: $t('data.provinces.Madrid', 'Madrid') },
    { value: "Málaga", text: $t('data.provinces.Málaga', 'Málaga') },
    { value: "Melilla", text: $t('data.provinces.Melilla', 'Melilla') },
    { value: "Murcia", text: $t('data.provinces.Murcia', 'Murcia') },
    { value: "Navarra", text: $t('data.provinces.Navarra', 'Navarra') },
    { value: "Ourense", text: $t('data.provinces.Ourense', 'Ourense') },
    { value: "Palencia", text: $t('data.provinces.Palencia', 'Palencia') },
    { value: "Pontevedra", text: $t('data.provinces.Pontevedra', 'Pontevedra') },
    { value: "Salamanca", text: $t('data.provinces.Salamanca', 'Salamanca') },
    { value: "Santa Cruz de Tenerife", text: $t('data.provinces.Santa Cruz de Tenerife', 'Santa Cruz de Tenerife') },
    { value: "Segovia", text: $t('data.provinces.Segovia', 'Segovia') },
    { value: "Sevilla", text: $t('data.provinces.Sevilla', 'Sevilla') },
    { value: "Soria", text: $t('data.provinces.Soria', 'Soria') },
    { value: "Tarragona", text: $t('data.provinces.Tarragona', 'Tarragona') },
    { value: "Teruel", text: $t('data.provinces.Teruel', 'Teruel') },
    { value: "Toledo", text: $t('data.provinces.Toledo', 'Toledo') },
    { value: "Valencia/València", text: $t('data.provinces.Valencia/València', 'Valencia/València') },
    { value: "Valladolid", text: $t('data.provinces.Valladolid', 'Valladolid') },
    { value: "Vizcaya/Bizkaia", text: $t('data.provinces.Vizcaya/Bizkaia', 'Vizcaya/Bizkaia') },
    { value: "Zamora", text: $t('data.provinces.Zamora', 'Zamora') },
    { value: "Zaragoza", text: $t('data.provinces.Zaragoza', 'Zaragoza') },
];
